import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import type { PersonFormInterface } from '@zaoblako/shared/modules/client/dtos/person/person-form.dto';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';

@Component({
  standalone: true,
  selector: 'crm-inn-auto-complete',
  templateUrl: './inn-auto-complete.component.html',
  imports: [CommonModule, AutoCompleteComponent, SafeHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InnAutoCompleteComponent {
  @ViewChild('innAutoComplete', { static: true }) public innAutoComplete: AutoCompleteComponent;

  @Input() public selectedPerson: PersonFormInterface;
  @Output() public selectedPersonChange = new EventEmitter<PersonFormInterface>();

  @Input() public persons: PersonFormInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public disabled = false;
  @Input() public appendTo: string;
  @Input() public autofocus = false;

  @Output() public personSearch = new EventEmitter<string>();

  public toPerson(person: any): PersonFormInterface {
    return person as PersonFormInterface;
  }

  public highlightMatchText(text: string): string {
    return HighlightMatchTextHelper.highlightMatchText(text, this.innAutoComplete?.autoComplete?.inputValue());
  }
}
